import { useEffect, useState } from 'react'

import { CompensationSettings } from 'app/dataTypes/subsidy/settings'
import { Tabs, Tab, TabPanels, TabPanel } from 'app/common/ui/PlainTabs'

import { Errors } from './useCompensationErrors'
import { IncludeFormCompensation } from './formParts/IncludeFormCompensation'
import { FormSection } from '../FormSection'
import { AccrualFormCompensation } from './formParts/AccrualFormCompensation'
import { AccuralsForFormCompensation } from './formParts/AccuralsForFormCompensation'
import { AdditionalFormCompensation } from './formParts/AdditionalFormCompensation'
import { AccrualPeriodFormCompensation } from './formParts/AccrualPeriodFormCompensation'

const tabTitles = ['Первая смена', 'Вторая смена', 'Третья смена']
const app = 'compensation' as const

type Props = {
  ID: string
  orgID: string
  formID: string
  settings: CompensationSettings
  disabled?: boolean
  errors: Errors
  resetErrors: () => void
  updateSize?: () => void
  onModify?: () => void
}

export const CategoryCompensationSettingsForm = ({
  ID,
  orgID,
  formID,
  settings,
  disabled,
  errors,
  resetErrors,
  updateSize,
  onModify,
}: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(1)

  const { accruals, accrualsFor, include, homeschoolingOnly, accrualPeriod } = settings

  useEffect(() => {
    if (errors.size) {
      const tabNumber = parseInt(Array.from(errors.keys())[0].replace(/\D/g, ''), 10)
      if (!Number.isNaN(tabNumber)) {
        setActiveTabIndex(tabNumber)
      }
    }
  }, [errors])

  useEffect(() => {
    updateSize?.()
  }, [activeTabIndex]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <FormSection>
        <Tabs value={activeTabIndex} onChange={setActiveTabIndex} skipUpperSpace>
          {accruals.map((_, i) => (
            <Tab
              index={i + 1}
              key={i} // eslint-disable-line react/no-array-index-key
            >
              {tabTitles[i]}
            </Tab>
          ))}
        </Tabs>

        <TabPanels value={activeTabIndex}>
          {accruals.map((accrual, i) => {
            const props = {
              ID,
              orgID,
              app,
              data: accrual,
              formID,
              disabled,
              errors,
              resetErrors,
              updateSize,
            }
            return (
              <TabPanel
                index={i + 1}
                key={i} // eslint-disable-line react/no-array-index-key
              >
                <AccrualFormCompensation {...props} />
              </TabPanel>
            )
          })}
        </TabPanels>
      </FormSection>

      <FormSection>
        <AccuralsForFormCompensation
          data={accrualsFor}
          disabled={disabled}
          formID={formID}
          errors={errors}
          resetErrors={resetErrors}
        />
      </FormSection>

      <FormSection>
        <IncludeFormCompensation
          data={include}
          disabled={disabled}
          formID={formID}
          errors={errors}
          resetErrors={resetErrors}
        />
      </FormSection>
      <FormSection>
        <AccrualPeriodFormCompensation
          accrualPeriod={accrualPeriod}
          disabled={disabled}
          formID={formID}
          errors={errors}
          resetErrors={resetErrors}
        />
      </FormSection>
      <FormSection>
        <AdditionalFormCompensation
          homeschoolingOnly={homeschoolingOnly}
          disabled={disabled}
          formID={formID}
          errors={errors}
          resetErrors={resetErrors}
        />
      </FormSection>
    </>
  )
}
